import routes from "../../app/routes";

export const getRoutes = (
  mctCurrentPlanYear: string
): { [x: string]: string } => {
  const { questionRouting, summary } = routes;
  const currentYear = parseInt(mctCurrentPlanYear, 10);
  const loggedInHomeRoute = summary.landingPage;
  const questionsRouteForThisYear = `${questionRouting}?year=${currentYear}`;
  const questionsRouteForNextYear = `${questionRouting}?year=${currentYear +
    1}`;
  const beneRouteForThisYear = `${loggedInHomeRoute}?year=${currentYear}`;
  const beneRouteForNextYear = `${loggedInHomeRoute}?year=${currentYear + 1}`;

  return {
    questionsRouteForThisYear,
    questionsRouteForNextYear,
    beneRouteForNextYear,
    beneRouteForThisYear,
  };
};
